import React from 'react';
import { Container } from 'react-bootstrap';
import { PortableHeader } from 'src/components/PortableHeader/PortableHeader';
import * as classes from './FlowListing.module.scss';
import { FlowListingItem } from './FlowListingItem';

export const FlowListing = ({ header, infoColumnTitle, listingColumnTitle, items }) => (
  <Container as="section" className={`py-5 ${classes.wrapper}`}>
    <PortableHeader content={header} className={classes.header} />
    <div className={classes.listItemsWrapper}>
      {items.map((e, i) => (
        <FlowListingItem index={i} key={e._key} infoColumnTitle={infoColumnTitle} listingColumnTitle={listingColumnTitle} {...e} />
      ))}
    </div>
  </Container>
);
